<template>
  <div class="container is-fluid">
    <p class="title is-3" align="center">Send A Message To Your Group</p><br>
    <div class="columns is-centered">
        <div class="column box is-one-third">
          <form>
            <label>Recipients</label>
            <select id="user" name="user">
              <option>All</option>
              <option>Specific User coming later</option>
            </select>

            <label for="subject">Subject</label>
            <input type="text"
              id="subject"
              name="subject"
              placeholder="Message Subject.."
              v-model="messageSubject">

            <label for="message">Message</label>
            <textarea id="message"
              name="message"
              placeholder="Write something.."
              style="height:200px"
              v-model="messageBody">
            </textarea>
          </form>

          <button @click="addMessage" class="button is-medium is-fullwidth">Send</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as firebase from 'firebase'

  export default {
    data() {
      return {
        messageBody: '',
        messageSubject:'',
        messageDate:''
      }
    },
    methods: {
      updateMessages(userId, key, message){
        firebase.database().ref('users').child(userId).child('messages/'+key).set(message)
      },
      setNewMessage(userId){
        firebase.database().ref('users').child(userId).update({
          newMessage: true,
        })
      },
      getDate(){
        let today = new Date()
        let dd = today.getDate()
        let mm = today.getMonth()+1
        let yyyy = today.getFullYear()

        if (dd<10) { dd = '0'+dd }

        if (mm<10) { mm = '0'+mm }

        today = mm + '/' + dd + '/' + yyyy
        return today
      },
      addMessage(){
        firebase.database().ref('users').once('value')
          .then((data) => {
            const obj = data.val()  // store all objects
            for (let key in obj) {  // for each key in the group
              let tempId = key
              let tempEmail = obj[key].email
              let tempLength = 0
              for (let mess in obj[key].messages){
                tempLength++
              }
              const newMessage = {
                date: this.getDate(),
                subject: this.messageSubject,
                message: this.messageBody
              }
              this.updateMessages(tempId,tempLength, newMessage)
              this.setNewMessage(tempId)
            }
            this.messageBody= ''
            this.messageSubject=''
            this.messageDate=''
            this.$toasted.show("Your message has been sent!", {
              theme: "outline",
              position: "bottom-center",
              duration : 3000,
              fitToScreen: true
            })
          })
          .catch((error) => { console.log(error) })
      },
    }
  }
</script>

<style scoped>
thead th {
  color: white;
}

/* Style inputs with type="text", select elements and textareas */
input[type=text], select, textarea {
    width: 100%; /* Full width */
    padding: 12px; /* Some padding */
    border: 1px solid #ccc; /* Gray border */
    border-radius: 4px; /* Rounded borders */
    box-sizing: border-box; /* Make sure that padding and width stays in place */
    margin-top: 6px; /* Add a top margin */
    margin-bottom: 16px; /* Bottom margin */
    resize: vertical /* Allow the user to vertically resize the textarea (not horizontally) */
}

/* Style the submit button with a specific background color etc */
input[type=submit] {
    background-color: purple;
    color: white;
    padding: 12px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

/* When moving the mouse over the submit button, add a darker green color */
input[type=submit]:hover {
    background-color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/adminMessaging.vue